import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Package, Calendar, Users, MapPin, Home } from 'lucide-react';

const navItems = [
  { path: '/envios', label: 'Envios', icon: Package, accent: '#3B82F6' },
  { path: '/pickups', label: 'Recogida', icon: Calendar, accent: '#F59E0B' },
  { path: '/', label: 'Inicio', icon: Home, isCenter: true, accent: '#6366F1' },
  { path: '/remitentes', label: 'Remitente', icon: Users, accent: '#10B981' },
  { path: '/destinatarios', label: 'Destino', icon: MapPin, accent: '#EF4444' },
];

const BottomNav = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <>
      {/* Spacer para evitar que el contenido quede detrás del nav */}
      <div className="h-20 sm:h-24" />

      <nav className="fixed bottom-0 left-0 right-0 z-50 safe-area-bottom" data-testid="bottom-nav">
        {/* Glass background con mejor contraste */}
        <div className="absolute inset-0 bg-white/95 backdrop-blur-xl border-t border-gray-200 shadow-[0_-4px_20px_rgba(0,0,0,0.08)]" />

        <div className="relative flex items-end justify-around max-w-lg mx-auto px-2 pb-2 pt-2">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;

            if (item.isCenter) {
              return (
                <button
                  key={item.path}
                  onClick={() => navigate(item.path)}
                  className="flex flex-col items-center -mt-5 group relative touch-manipulation"
                  data-testid="bottom-nav-inicio"
                >
                  {/* Glow ring */}
                  {isActive && (
                    <div className="absolute top-0 w-[64px] h-[64px] rounded-full opacity-30 animate-ping"
                      style={{ background: item.accent }} />
                  )}
                  <div
                    className="w-[56px] h-[56px] rounded-2xl flex items-center justify-center shadow-lg transition-all duration-300 active:scale-95"
                    style={{
                      background: `linear-gradient(135deg, ${item.accent}, #002D62)`,
                      boxShadow: isActive
                        ? `0 8px 24px ${item.accent}50, 0 0 0 3px ${item.accent}30`
                        : `0 4px 12px rgba(0,0,0,0.15)`,
                      transform: isActive ? 'scale(1.05) translateY(-2px)' : undefined,
                    }}>
                    <Icon className="h-6 w-6 text-white" strokeWidth={2.5} />
                  </div>
                  <span className="text-[11px] font-bold mt-1"
                    style={{ color: isActive ? item.accent : '#374151' }}>
                    {item.label}
                  </span>
                </button>
              );
            }

            return (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                className="flex flex-col items-center py-1.5 px-2 min-w-[56px] group relative touch-manipulation"
                data-testid={`bottom-nav-${item.label.toLowerCase()}`}
              >
                {/* Active indicator line */}
                {isActive && (
                  <div className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-1 rounded-full transition-all duration-300"
                    style={{ background: item.accent }} />
                )}

                <div
                  className="p-2 rounded-xl transition-all duration-300 active:scale-95"
                  style={{
                    background: isActive ? `${item.accent}15` : 'transparent',
                    transform: isActive ? 'translateY(-2px)' : undefined,
                  }}>
                  <Icon
                    className="h-6 w-6 transition-all duration-300"
                    strokeWidth={isActive ? 2.5 : 2}
                    style={{ color: isActive ? item.accent : '#6B7280' }}
                  />
                </div>
                <span
                  className="text-[10px] font-bold mt-0.5 transition-colors duration-300"
                  style={{ color: isActive ? item.accent : '#374151' }}>
                  {item.label}
                </span>
              </button>
            );
          })}
        </div>
      </nav>
    </>
  );
};

export default BottomNav;
